import { render, staticRenderFns } from "./EmasculationPollinationCommentsComponent.vue?vue&type=template&id=38e51fda&scoped=true&"
import script from "./EmasculationPollinationCommentsComponent.vue?vue&type=script&lang=js&"
export * from "./EmasculationPollinationCommentsComponent.vue?vue&type=script&lang=js&"
import style0 from "./EmasculationPollinationCommentsComponent.vue?vue&type=style&index=0&id=38e51fda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e51fda",
  null
  
)

export default component.exports